// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 5279 ? "6c44d60f" : chunkId) + "." + {"5279":"9845ed84a17b9d7d","7229":"d51dc260e03779fb"}[chunkId] + ".js";
};